import getHistory from './history';
import getNextRedo from './next-redo';
import getNextUndo from './next-undo';
import getStatus from './status';

export default {
  getHistory,
  getNextRedo,
  getNextUndo,
  getStatus,
};
